export const getOpenShiftEmployeeUserId = (employee) =>
  employee?.user?.id || null;

export const getOpenShiftEmployeeSchedulePersonId = (employee) =>
  employee?.scheduling_app_user_id || getOpenShiftEmployeeUserId(employee);

export const normalizeOpenShiftUserId = (userId) =>
  userId == null ? null : String(userId);

export const shouldResolveOpenShiftRequest = (
  assignmentRequested,
  shiftSaveType
) => Boolean(assignmentRequested && shiftSaveType === "edit");

export const getAssignableOpenShiftEmployees = (
  employees,
  roleId,
  pendingPickupUserIds = []
) => {
  const bidderUserIds = new Set(
    pendingPickupUserIds.map(normalizeOpenShiftUserId)
  );

  return (Array.isArray(employees) ? employees : [])
    .filter((employee) => {
      if (
        ["archived", "hidden"].includes(employee?.status) ||
        getOpenShiftEmployeeUserId(employee) == null
      ) {
        return false;
      }

      if (roleId == null) {
        return true;
      }

      const availableRoles = Array.isArray(employee?.available_role_info)
        ? employee.available_role_info
        : employee?.roles_and_role_types;

      return (
        Array.isArray(availableRoles) &&
        availableRoles.some((role) => role.scheduled_role === roleId)
      );
    })
    .sort((a, b) => {
      const aHasBid = bidderUserIds.has(
        normalizeOpenShiftUserId(getOpenShiftEmployeeUserId(a))
      );
      const bHasBid = bidderUserIds.has(
        normalizeOpenShiftUserId(getOpenShiftEmployeeUserId(b))
      );
      if (aHasBid !== bHasBid) {
        return aHasBid ? -1 : 1;
      }

      const aName = `${a?.first_name || ""} ${a?.last_name || ""}`.trim();
      const bName = `${b?.first_name || ""} ${b?.last_name || ""}`.trim();
      return aName.localeCompare(bName);
    });
};

export const buildOpenShiftSavePayload = (
  shift,
  breakChecked,
  secondBreakChecked,
  employee
) => ({
  ...shift,
  hours:
    shift.shift_end -
    shift.shift_start -
    (breakChecked ? shift.break_length : 0) -
    (secondBreakChecked ? shift.break_length_2 : 0),
  shift_length: shift.shift_end - shift.shift_start,
  break_length: breakChecked ? shift.break_length : 0,
  break_start: breakChecked ? shift.break_start : shift.shift_start,
  break_length_2: secondBreakChecked ? shift.break_length_2 : 0,
  break_start_2: secondBreakChecked ? shift.break_start_2 : 0,
  status: employee ? "TAKEN" : "AVAILABLE",
  store_team_member: employee?.id || null,
  person: getOpenShiftEmployeeSchedulePersonId(employee),
  resolve_open_shift_assignment: Boolean(employee && shift.id),
});
